export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3525.f49d5718.jpg";